// extracted by mini-css-extract-plugin
module.exports = {"alertLength":"7000"};